import { SxProps, Theme } from '@mui/material'

export const MULTI_STRIKE_METADATA_ROW_CLASS = 'multi-strike-metadata-row'
export const MULTI_STRIKE_METADATA_ACTIONS_CLASS = 'multi-strike-metadata-actions'

const COLUMN_GAP = 8

const tabularSx = {
    fontVariantNumeric: 'tabular-nums',
    fontFeatureSettings: '"tnum" on, "lnum" on',
} as const

export const MULTI_STRIKE_METADATA_TABLE_SX: SxProps<Theme> = {
    display: 'table',
    tableLayout: 'auto',
    borderCollapse: 'collapse',
    borderSpacing: 0,
    fontWeight: 500,
    fontSize: '13px',
    width: 'auto',
    pointerEvents: 'all',
    ...tabularSx,
}

export const getMultiStrikeMetadataTableRowSx = (theme: Theme): SxProps<Theme> => ({
    display: 'table-row',
    height: '24px',
    position: 'relative',
    pointerEvents: 'all',
    '& > td': {
        transition: 'background-color 0.1s ease-in',
    },
    '&:hover > td': {
        backgroundColor: theme.palette.background.paper,
    },
    '&:hover > td:first-of-type': {
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
    },
    '&:hover > td:last-of-type': {
        borderTopRightRadius: '4px',
        borderBottomRightRadius: '4px',
    },
    [`&:hover .${MULTI_STRIKE_METADATA_ACTIONS_CLASS}`]: {
        opacity: 1,
        pointerEvents: 'all',
    },
})

export const MULTI_STRIKE_METADATA_TABLE_CELL_SX: SxProps<Theme> = {
    display: 'table-cell',
    verticalAlign: 'middle',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    paddingRight: `${COLUMN_GAP}px`,
    ...tabularSx,
}

export const MULTI_STRIKE_METADATA_STRIKE_CELL_SX: SxProps<Theme> = {
    ...MULTI_STRIKE_METADATA_TABLE_CELL_SX,
    paddingRight: `${COLUMN_GAP}px`,
}

/** @deprecated Use MULTI_STRIKE_METADATA_STRIKE_CELL_SX */
export const MULTI_STRIKE_METADATA_STRIKE_SLOT_SX = MULTI_STRIKE_METADATA_STRIKE_CELL_SX

export const MULTI_STRIKE_METADATA_LABEL_CELL_SX: SxProps<Theme> = {
    ...MULTI_STRIKE_METADATA_TABLE_CELL_SX,
    cursor: 'pointer',
}

export const MULTI_STRIKE_METADATA_VALUE_CELL_SX: SxProps<Theme> = {
    ...MULTI_STRIKE_METADATA_TABLE_CELL_SX
}

export const MULTI_STRIKE_METADATA_OUTLOOK_CELL_SX: SxProps<Theme> = {
    ...MULTI_STRIKE_METADATA_TABLE_CELL_SX,
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: 1,
    position: 'relative',
    paddingRight: '20px',
    minWidth: '28px',
}

export const MULTI_STRIKE_METADATA_ACTIONS_SX = {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 0.1s ease-in',
} as const

/** Header / non-table metadata rows — no border. */
export const getMultiStrikeMetadataRowSx = (theme: Theme, options?: { fullWidth?: boolean }): SxProps<Theme> => ({
    pointerEvents: 'all',
    width: options?.fullWidth ? '100%' : 'fit-content',
    maxWidth: options?.fullWidth ? '100%' : undefined,
    fontSize: '14px',
    height: '24px',
    boxSizing: 'border-box',
    position: 'relative',
    borderRadius: '4px',
    transition: 'background-color 0.1s ease-in',
    '&:hover': {
        backgroundColor: theme.palette.background.paper,
    },
    [`&:hover .${MULTI_STRIKE_METADATA_ACTIONS_CLASS}`]: {
        opacity: 1,
        pointerEvents: 'all',
    },
})
